<div [formGroup]="form1">

  <!-- ── HEADER ── -->
  <div class="kbm-modal-header">
    <div>
      <div class="header-eyebrow">
        {{isNew ? 'Reservations' : (reservation?.reservationNumber || 'Reservation')}}
      </div>
      <h2 class="header-title">{{formTitle}}</h2>
    </div>
    <button class="close-btn" mat-dialog-close>✕</button>
  </div>

  <!-- ── TAB BAR ── -->
  <div class="kbm-modal-tabs">
    <button *ngFor="let t of TABS" class="modal-tab" [class.active]="activeTab === t" (click)="activeTab = t">
      {{t | titlecase}}
    </button>
  </div>

  <!-- ── BODY ── -->
  <div class="kbm-modal-body">

    <!-- ══ DETAILS TAB ══ -->
    <ng-container *ngIf="activeTab === 'details'">

      <div class="kbm-section-label"><span>Reservation Lookup</span></div>
      <div class="row" style="margin-bottom:16px">
        <div class="col-lg-6">
          <app-reservation-select
            [placeholder]="'Enter reservation id and select'"
            (reservationInfoEvent)="reservationInfoItem($event)"
            [title]="title"
            [reservationId]="reservationId">
          </app-reservation-select>
          <span>
            <small class="p-invalid" *ngIf="isReservationId">Reservation is required</small>
          </span>
        </div>
      </div>

      <div class="kbm-section-label"><span>Guest Information</span></div>
      <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
        <div class="kbm-field">
          <label class="kbm-label">First Name <span class="req">*</span></label>
          <input class="kbm-input" formControlName="firstName" placeholder="First name"/>
          <div *ngIf="errMsg('firstName')" class="kbm-hint" style="color:#ef4444">{{errMsg('firstName')}}</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Last Name <span class="req">*</span></label>
          <input class="kbm-input" formControlName="lastName" placeholder="Last name"/>
          <div *ngIf="errMsg('lastName')" class="kbm-hint" style="color:#ef4444">{{errMsg('lastName')}}</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Email <span class="req">*</span></label>
          <input class="kbm-input" type="email" formControlName="email" placeholder="guest@email.com"/>
          <div *ngIf="errMsg('email')" class="kbm-hint" style="color:#ef4444">{{errMsg('email')}}</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Phone</label>
          <input class="kbm-input" type="tel" formControlName="phone" placeholder="(000) 000-0000"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Number of Guests <span class="req">*</span></label>
          <input class="kbm-input" type="number" min="1" formControlName="numGuests"/>
          <div *ngIf="errMsg('numGuests')" class="kbm-hint" style="color:#ef4444">{{errMsg('numGuests')}}</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Special Requests / Needs</label>
          <input class="kbm-input" formControlName="specialRequests" placeholder="Dietary, accessibility, etc."/>
        </div>
      </div>

      <div class="kbm-section-label"><span>Stay Information</span></div>
      <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
        <div class="kbm-field">
          <label class="kbm-label">Resort Name <span class="req">*</span></label>
          <input class="kbm-input" formControlName="property" placeholder="Auto-populated from reservation or enter manually"/>
          <div *ngIf="errMsg('property')" class="kbm-hint" style="color:#ef4444">{{errMsg('property')}}</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Property Code</label>
          <input class="kbm-input" formControlName="unit" placeholder="Auto-populated from reservation or enter manually"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Check-In Date</label>
          <input class="kbm-input" type="date" formControlName="checkIn"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Check-Out Date</label>
          <input class="kbm-input" type="date" formControlName="checkOut"/>
        </div>
      </div>

      <div class="kbm-section-label"><span>Booking Status</span></div>
      <div class="kbm-field-grid cols-2">
        <div class="kbm-field">
          <label class="kbm-label">Booking Status</label>
          <select class="kbm-select" formControlName="bookingStatus">
            <option value="">Select status…</option>
            <option *ngFor="let s of BOOKING_STATUSES" [value]="s.value">{{s.name}}</option>
          </select>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Activity Date</label>
          <input class="kbm-input" type="date" formControlName="activityDate"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Preferred Start Time</label>
          <select class="kbm-select" formControlName="preferredTime">
            <option value="">Select time…</option>
            <option *ngFor="let t of TIME_SLOTS" [value]="t.value">{{t.name}}</option>
          </select>
        </div>
      </div>

      <div class="kbm-section-label"><span>Payment</span></div>
      <div class="kbm-field-grid cols-2">
        <div class="kbm-field">
          <label class="kbm-label">Amount Due ($)</label>
          <input class="kbm-input" type="number" min="0" step="0.01" formControlName="amountDue" placeholder="0.00"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Amount Paid ($)</label>
          <input class="kbm-input" type="number" min="0" step="0.01" formControlName="amountPaid" placeholder="0.00"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Payment Status</label>
          <select class="kbm-select" formControlName="paymentStatus">
            <option *ngFor="let s of PAY_STATUSES" [value]="s.value">{{s.name}}</option>
          </select>
        </div>
        <div class="kbm-field" style="display:flex;align-items:flex-end">
          <div style="font-size:12px;color:#6b7280">
            Balance: <span style="font-weight:700" [style.color]="balance > 0 ? '#dc2626' : '#059669'">{{fmt$(balance)}}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ══ ACTIVITIES TAB ══ -->
    <ng-container *ngIf="activeTab === 'activities'">

      <div class="kbm-section-label"><span>Booked Activities</span></div>
      <p style="font-size:12px;color:#9ca3af;margin:0 0 12px">Select all activities included in this reservation.</p>

      <div style="border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;margin-bottom:16px">
        <label *ngFor="let a of activeActivities"
          style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;cursor:pointer;border-bottom:1px solid #f3f4f6;transition:background 0.1s"
          [style.background]="isActivitySelected(a.activityId) ? '#ecfdf5' : '#fff'">
          <div style="display:flex;align-items:center;gap:12px">
            <input type="checkbox"
              [checked]="isActivitySelected(a.activityId)"
              (change)="toggleActivity(a.activityId)"
              style="width:16px;height:16px;accent-color:#059669"/>
            <span style="font-size:20px">{{a.emoji}}</span>
            <div>
              <div style="font-size:13px;font-weight:600;color:#1f2937">{{a.name}}</div>
              <div style="font-size:11px;color:#9ca3af">{{a.duration}} · {{a.rate}}/pp</div>
            </div>
          </div>
          <span class="badge-kbm badge-{{a.category}}">{{a.category}}</span>
        </label>
        <div *ngIf="activeActivities.length === 0" style="padding:24px;text-align:center;color:#9ca3af;font-size:13px">
          No active activities available.
        </div>
      </div>

      <!-- Selected summary -->
      <div *ngIf="selectedActIds.length > 0" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:8px;padding:12px 16px">
        <div style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:8px">
          Selected ({{selectedActIds.length}})
        </div>
        <div style="display:flex;flex-wrap:wrap;gap:8px">
          <span *ngFor="let a of selectedActivityObjects"
            style="display:inline-flex;align-items:center;gap:4px;padding:4px 10px;background:#d1fae5;color:#065f46;font-size:12px;font-weight:600;border-radius:6px">
            {{a.emoji}} {{a.name}}
          </span>
        </div>
      </div>
    </ng-container>

    <!-- ══ NOTES TAB ══ -->
    <ng-container *ngIf="activeTab === 'notes'">

      <div class="kbm-section-label"><span>Internal Notes</span></div>
      <textarea class="kbm-textarea" formControlName="staffNotes" rows="6"
        placeholder="Staff notes, follow-ups, provider confirmations, guest communication history…"></textarea>
      <p style="font-size:11px;color:#9ca3af;margin:6px 0 20px">
        These notes are visible to KBM staff only and are not shared with guests.
      </p>

      <div class="kbm-section-label"><span>Special Requests</span></div>
      <textarea class="kbm-textarea" formControlName="specialRequests" rows="3"
        placeholder="Guest-provided special requests or needs…"></textarea>
    </ng-container>

  </div><!-- /kbm-modal-body -->

  <!-- ── FOOTER ── -->
  <div class="kbm-modal-footer">
    <div>
      <button *ngIf="!isNew" class="btn-kbm-danger-outline btn-kbm-sm" (click)="cancelReservation()">
        Cancel Reservation
      </button>
    </div>
    <div style="display:flex;gap:8px;margin-left:auto">
      <button class="btn-kbm-outline" mat-dialog-close [disabled]="formLoading">Discard</button>
      <button class="btn-kbm-primary" (click)="save()" [disabled]="formLoading">
        {{formLoading ? 'Saving…' : 'Save Reservation'}}
      </button>
    </div>
  </div>

</div>
